import React from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import Image from "components/Elements/Image/Image.tsx";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import parse from "html-react-parser";
const FormBuilderHeader = ({
  detailsMode,
  showImage,
  formImage,
  showTitle,
  formDescription,
  showDescription,
  formDisplayTitle,
  emptyHeader,
  openTitleAndDescription,
}) => {
  const { getTextByKey } = useContent();
  return (
    <div
      className={`header ${detailsMode === "form-details" ? "active" : ""} ${
        emptyHeader ? "empty-header-container" : ""
      }`}
    >
      {!emptyHeader && (
        <div className="header-content">
          {formImage && showImage && (
            <div className="image">
              <Image src={formImage} alt="" title="" />
            </div>
          )}
          <div
            className={`content ${
              !formImage || !showImage ? "full-width" : ""
            }`}
          >
            {showTitle && formDisplayTitle && (
              <h2>{parse(formDisplayTitle)}</h2>
            )}
            {formDescription &&
              showDescription &&
              (formDescription.length > 80 ? (
                <Tooltip
                  id="full-description-form"
                  tooltipText={parse(formDescription)}
                  top
                >
                  <span className="description-text">
                    {parse(formDescription)}
                  </span>
                </Tooltip>
              ) : (
                <span className="description-text">
                  {parse(formDescription)}
                </span>
              ))}
          </div>
        </div>
      )}
      {!emptyHeader ? (
        <div className="edit-header" onClick={() => openTitleAndDescription()}>
          <Icon name="pencil-alt-solid" />
        </div>
      ) : (
        <div className="empty-header" onClick={() => openTitleAndDescription()}>
          <Icon name={"plus"} />
          <span>{getTextByKey("add-details")}</span>
        </div>
      )}
    </div>
  );
};

export default FormBuilderHeader;
